import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop", "submenu"]

  connect() {
    if (!this.hasMenuTarget) {
      this._menuEl = document.getElementById("mobile-menu")
    }
    if (!this.hasBackdropTarget) {
      this._backdropEl = document.getElementById("mobile-backdrop")
    }
  }

  get _menu() {
    return this.hasMenuTarget ? this.menuTarget : this._menuEl
  }

  get _backdrop() {
    return this.hasBackdropTarget ? this.backdropTarget : this._backdropEl
  }


  toggle() {
    if (this._menu.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this._menu.classList.remove("translate-x-full")
    this._backdrop.classList.remove("hidden")
    setTimeout(() => {
      this._backdrop.classList.add("bg-opacity-50")
      this._backdrop.classList.remove("bg-opacity-0")
    }, 10)
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this._menu.classList.add("translate-x-full")
    this._backdrop.classList.add("bg-opacity-0")
    this._backdrop.classList.remove("bg-opacity-50")
    setTimeout(() => {
      this._backdrop.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 300)
  }

  toggleSubmenu(event) {
    event.preventDefault()
    const button = event.currentTarget
    const submenu = button.nextElementSibling
    const icon = button.querySelector('svg')

    if (submenu) {
      const isHidden = submenu.classList.contains("hidden")

      if (isHidden) {
        // 展开动画
        submenu.classList.remove("hidden")
        submenu.style.overflow = "hidden"
        submenu.style.maxHeight = "0px"
        submenu.style.transition = "max-height 0.3s ease-out"

        // 强制浏览器重绘，然后展开
        setTimeout(() => {
          submenu.style.maxHeight = submenu.scrollHeight + "px"
        }, 10)

        // 动画结束后清理样式
        setTimeout(() => {
          submenu.style.maxHeight = ""
          submenu.style.overflow = ""
          submenu.style.transition = ""
        }, 310)
      } else {
        // 收起动画
        submenu.style.maxHeight = submenu.scrollHeight + "px"
        submenu.style.overflow = "hidden"
        submenu.style.transition = "max-height 0.3s ease-out"

        // 强制浏览器重绘，然后收起
        setTimeout(() => {
          submenu.style.maxHeight = "0px"
        }, 10)

        // 动画结束后添加 hidden 类
        setTimeout(() => {
          submenu.classList.add("hidden")
          submenu.style.maxHeight = ""
          submenu.style.overflow = ""
          submenu.style.transition = ""
        }, 310)
      }

      if (icon) {
        icon.classList.toggle("rotate-180")
      }
    }
  }
}
